/* Ultras Switzerland: header-height token for the game layout and ticker pause control. */
(function () {
  function setHeaderHeight() {
    var groups = document.querySelectorAll('.shopify-section-group-header-group');
    var h = 0;
    groups.forEach(function (g) { h += g.getBoundingClientRect().height; });
    if (h) document.documentElement.style.setProperty('--ultras-header-h', Math.round(h) + 'px');
  }
  function initTicker() {
    document.querySelectorAll('.ultras-ticker').forEach(function (el) {
      var btn = el.querySelector('.ultras-ticker__pause');
      if (!btn || btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var paused = el.toggleAttribute('data-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.textContent = paused ? btn.dataset.play : btn.dataset.pause;
      });
    });
  }
  function initProperties() {
    var form = document.querySelector('product-form form[id^="product-form"]');
    if (!form) return;
    document.querySelectorAll('[data-ultras-property]').forEach(function (el) { el.setAttribute('form', form.id); });
  }
  function init() { setHeaderHeight(); initTicker(); initProperties(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('shopify:section:load', init);
})();
